module.exports = __webpack_public_path__ + "static/media/ic_accept.c037c1d2.svg";